"use client";

import {DashboardFilter} from "@/components/@filter/dashboard-filter";
import {
  ContactForm,
  DashboardSetting,
  ProfileForm,
  SmartEdit
} from "@/components/pages";
import {Modal, ModalBody, ModalContent, ModalFooter} from "@nextui-org/react";
import React, {useEffect, useState} from "react";
import {AiFillCloseCircle} from "react-icons/ai";
import {DeActivateModal, DeleteModal, ResetPasswordModal} from ".";
import {NeoButton} from "../forms";
import {AttachmentTripRating} from "../pages/bookings/tripRating/attachmentTripRating";
import {CreditsPointForm} from "../pages/creditspointsoverview/creditspointform";
import {CreditsPointsOverview} from "../pages/creditspointsoverview/creditspointsoverview";
import {DashboardReport} from "../pages/dashboard/dashboard-report";
import {WidgetOrdering} from "../pages/dashboard/widgetordering";
import {DriverFormv2} from "../pages/drivers/driver-formv2";
import {DocumentsGrid} from "../pages/expensereports/documentgrid";
import {ExpenseAddCommonForm} from "../pages/expensereports/expenseadd";
import {ExpenseFuelForm} from "../pages/expensereports/expensefuelform";
import {ExpenseMaintanceForm} from "../pages/expensereports/expensemaintenanceform";
import {ExpenseMiscellaneousForm} from "../pages/expensereports/expensemiscellaneousform";
import {FleetForm} from "../pages/fleet/fleetform";
import {FuelAnalytics} from "../pages/fuelanalytics/fuelanalytics";
import {FuelConsumption} from "../pages/fuelanalytics/fuelconsumption";
import {PaymentReminder} from "../pages/live/paymentReminder";
import {CommonReportTable} from "../pages/reports/commonTableView";
import {ReportUi} from "../pages/reports/report-ui";
import {CreateRoutePlan} from "../pages/routes/planOptimizer/createPlanForm";
import {ProcessingPopup} from "../pages/routes/planOptimizer/processingPopup";
import {DeletetBpwindow} from "../pages/routes/routePlanWidgets/optimizer/deleteBp/deleteForm";
import {EditBpwindow} from "../pages/routes/routePlanWidgets/optimizer/editBp/bpEditForm";
import {InputParamsError} from "../pages/routes/routePlanWidgets/optimizer/leftWidgets/view_download_outputData/inputError";
import {ViewOutputData} from "../pages/routes/routePlanWidgets/optimizer/leftWidgets/view_download_outputData/viewOutputData";
import {UserMappingUnMapping} from "../pages/routes/routePlanWidgets/optimizer/modals/userMappingUnMapping";
import {RfidEdit} from "../pages/users/rfid-edit";
import {AssignDriver} from "../pages/vehicles/assigndriver";
import {EditVehicleConfirmation} from "./editVehicleConfirmation";
import {ConfirmationPopup} from "./routePlan/confirmation";
type NeoModalProps = {
  data?: any | null;
  actionType: string | null;
  onOpen: any;
  onClose: any;
  onModalSubmit?: (payload?: any) => void;
  actionText?: string;
  hasActions?: boolean;
  selectedRow?: any;
};

type ModalSize =
  | "4xl"
  | "md"
  | "xs"
  | "sm"
  | "lg"
  | "xl"
  | "2xl"
  | "3xl"
  | "5xl"
  | "full"
  | undefined;

/**
 * Generic modal dialog for all the popups
 *
 * If you need the buttons to be controlled from the component
 * please pass hasActions as true, and create a function called onModalSubmit
 * and pass them as functional reference
 * If you dont want yes & no button from neo modal design the button inside the component and pass hasActions to false.
 * You dont have to pass the functional refernce for modal submit you only need onclose & onopen
 * For example, please check neo-table where both the usecase are handled
 *
 */
export const NeoModal: React.FC<NeoModalProps> = ({
  actionType,
  onOpen,
  onClose,
  onModalSubmit,
  actionText = "Yes",
  data,
  hasActions = true,
  selectedRow
}) => {
  const [size, setSize] = useState<ModalSize>("md");
  const [content, setContent] = useState<React.ReactNode | null>(null);
  const [CloseIcon, setCloseIcon] = useState(false);
  const [hideCloseButton, setHideCloseButton] = useState(false);
  useEffect(() => {
    switch (actionType) {
      case "delete":
        setSize("md");
        setContent(<DeleteModal />);
        break;
      case "smart_edit":
        setSize("2xl");
        setContent(<SmartEdit selectedRow={selectedRow} onClose={onClose} />);
        break;
      case "change-mobile":
        setContent(
          <ProfileForm
            mobileNumber={data?.mobileNumber}
            formType={actionType}
            onClose={onClose}
          />
        );
        break;
      case "change-password":
        setContent(
          <ProfileForm
            mobileNumber={data?.mobileNumber}
            formType={actionType}
            onClose={onClose}
          />
        );
        break;
      case "reset_rfid":
        setSize("4xl");
        setContent(<RfidEdit onClose={onClose} selectedRow={selectedRow} />);
        break;
      case "resetpassword":
        setSize("md");
        setContent(<ResetPasswordModal />);
        break;
      case "deactivate":
        setSize("lg");
        setContent(<DeActivateModal />);
        break;
      case "report":
        setSize("full");
        setContent(<ReportUi reportdata={data} />);
        setCloseIcon(true);
        break;
      case "contactform":
        setSize("lg");
        setContent(<ContactForm />);
        setCloseIcon(true);
        break;
      case "dashboardreport":
        setSize("5xl");
        setContent(<DashboardReport reportdata={data} />);
        setCloseIcon(true);
        break;
      case "dashboardsetting":
        setSize("md");
        setContent(
          <DashboardSetting onSubmit={onModalSubmit} settingdatas={data} />
        );
        setCloseIcon(true);
        break;
      case "dashboardfilter":
        setSize("md");
        setContent(
          <DashboardFilter onSubmit={onModalSubmit} searchinstitutes={data} />
        );
        setCloseIcon(true);
        break;
      case "widgetordering":
        setSize("lg");
        setContent(
          <WidgetOrdering onSubmit={onModalSubmit} orderingdatas={data} />
        );
        setCloseIcon(true);
        break;
      case "paymentReminder":
        setSize("lg");
        setContent(<PaymentReminder data={data} />);
        setCloseIcon(true);
        break;
      case "addeditDriver":
        setSize("xl");
        setContent(<DriverFormv2 data={data} onClose={onClose} />);
        setCloseIcon(true);
        break;
      case "assigndriver":
        setSize("md");
        setContent(
          <AssignDriver datas={data} onSubmit={onModalSubmit ?? (() => {})} />
        );
        break;
      case "fleetform":
        setSize("md");
        setContent(
          <FleetForm
            header={actionText}
            datas={data}
            onSubmit={onModalSubmit ?? (() => {})}
          />
        );
        setCloseIcon(true);
        break;
      case "editVehicleConfirmation":
        setSize("md");
        setContent(<EditVehicleConfirmation data={data} />);
        break;
      case "fuelform":
        setSize("4xl");
        setContent(
          <ExpenseFuelForm
            key={data?.id ?? "new"}
            data={{...data}}
            onSubmit={onModalSubmit ?? (() => {})}
            onClose={onClose ?? (() => {})}
          />
        );
        setCloseIcon(true);
        break;
      case "maintenanceform":
        setSize("2xl");
        setContent(
          <ExpenseMaintanceForm
            key={data?.id ?? "new"}
            data={{...data}}
            onSubmit={onModalSubmit ?? (() => {})}
            onClose={onClose ?? (() => {})}
          />
        );
        setCloseIcon(true);
        break;
      case "miscellaneousform":
        setSize("2xl");
        setContent(
          <ExpenseMiscellaneousForm
            key={data?.id ?? "new"}
            data={{...data}}
            onSubmit={onModalSubmit ?? (() => {})}
            onClose={onClose ?? (() => {})}
          />
        );
        setCloseIcon(true);
        break;
      case "documentgrid": {
        const docsCount: any = data?.documents?.length;
        if (docsCount === 1) {
          setSize("md");
        } else if (docsCount == 2) {
          setSize("2xl");
        } else if (docsCount == 3) {
          setSize("4xl");
        }

        setContent(
          <DocumentsGrid
            key={data?.id ?? "new"}
            title="Documents"
            data={data}
            onSubmit={onModalSubmit ?? (() => {})}
          />
        );
        setCloseIcon(true);
        break;
      }
      case "expensesadd":
        setSize("xs");
        setContent(
          <ExpenseAddCommonForm onSubmit={onModalSubmit ?? (() => {})} />
        );
        setCloseIcon(true);
        break;
      case "addPlanOptimizer":
        setSize("sm");
        setContent(<CreateRoutePlan editData={data} onClose={onClose} />);
        //setCloseIcon(true);
        break;
      case "creditUsageOverview":
        setSize("full");
        setContent(<CreditsPointsOverview />);
        setCloseIcon(true);
        break;
      case "creditspointform":
        setSize("md");
        setContent(
          <CreditsPointForm
            onSubmit={onModalSubmit ?? (() => {})}
            onClose={onClose ?? (() => {})}
          />
        );
        setCloseIcon(true);
        break;
      case "tableView":
        setSize("5xl");
        setContent(<CommonReportTable reportdata={data} />);
        setCloseIcon(true);
        break;
      case "routePlanProcessingPopup":
        setSize("sm");
        setContent(
          <ProcessingPopup
            changeVariant={data.changeVariant}
            newAddedVariantId={data.newAddedVariantId}
            setIsHistoryTab={data.setIsHistoryTab}
            type={data.type ? data.type : "newVariant"}
            closePopup={onClose}
          />
        );
        setHideCloseButton(true);
        break;
      case "userMappping":
        setSize("sm");
        setContent(
          <UserMappingUnMapping
            routeData={data.routeData}
            userData={data.userData}
            variantId={data.variantId}
            setCurrentVariant={data.setCurrentVariant}
            refreshSingleRoute={data.refreshSingleRoute}
            handleCloseModal={data.handleCloseModal}
            index={data.index}
          />
        );
        break;
      case "boardingConformation":
        setSize("sm");
        setContent(
          <ConfirmationPopup
            onConfirm={data.onConfirm}
            message={data.message}
            closePopup={onClose}
            reqData={data.reqData}
          />
        );
        break;
      case "exchangeRoute":
        setSize("sm");
        setContent(
          <EditBpwindow
            variantId={data.variantId}
            sourceRoute={data.sourceRoute}
            bpData={data.bpData}
            variantRoute={data.variantRoute}
            currentVariant={data.currentVariant}
            setCurrentVariant={data.setCurrentVariant}
            closePopup={onClose}
            refreshSingleRoute={data.refreshSingleRoute}
          />
        );
        break;
      case "deleteRouteBP":
        setSize("sm");
        setContent(
          <DeletetBpwindow
            variantId={data.variantId}
            sourceRoute={data.sourceRoute}
            bpData={data.bpData}
            variantRoute={data.variantRoute}
            currentVariant={data.currentVariant}
            setCurrentVariant={data.setCurrentVariant}
            closePopup={onClose}
            refreshSingleRoute={data.refreshSingleRoute}
          />
        );
        break;
      case "fuelanalytics":
        setSize("full");
        setContent(<FuelAnalytics reportdata={data} />);
        break;
      case "fuelconsumption":
        setSize("full");
        setContent(<FuelConsumption reportdata={data} />);
        break;

      case "viewDownloadRPOutput":
        setSize("5xl");
        setContent(
          <>
            <ViewOutputData
              exportData={data.exportData}
              selectedOption={data.selectedOption}
              vehicleTableData={data.vehicleTableData}
            />
          </>
        );
        break;
      case "routeOptimizerInputError":
        setSize("md");
        setContent(<InputParamsError errorMessage={data.errorMessage} />);
        break;
      case "attachmentPreviewTripRating":
        setSize("md");
        setContent(
          <AttachmentTripRating
            imageSrc={data?.imageSrc}
            fileType={data?.fileType}
          />
        );
        setCloseIcon(true);
        break;
      case "cancelTracker":
        setSize("sm");
        setContent(
          <div className="p-4 text-center text-sm text-gray-600">
            {data?.message}
          </div>
        );
        break;
      default:
        setContent(null);
    }
  }, [actionType, data?.mobileNumber, onClose, onModalSubmit, selectedRow]);

  return (
    <Modal
      backdrop="blur"
      scrollBehavior={actionType === "report" ? "outside" : undefined}
      size={size}
      isOpen={onOpen}
      onClose={onClose}
      closeButton={CloseIcon ? <AiFillCloseCircle size={50} /> : ""}
      hideCloseButton={hideCloseButton}
      isKeyboardDismissDisabled={hideCloseButton}
      isDismissable={!hideCloseButton}
    >
      <ModalContent>
        {onClose => (
          <>
            <ModalBody
              className="p-4"
              style={
                CloseIcon
                  ? {
                      flex: 1,
                      overflowY: "auto",
                      maxHeight: "100vh"
                    }
                  : {}
              }
            >
              {content}
            </ModalBody>
            {hasActions && (
              <ModalFooter className="justify-center py-5">
                <NeoButton color="white" onPress={onClose}>
                  Close
                </NeoButton>
                <NeoButton
                  color={actionType === "delete" ? "red" : "black"}
                  onPress={onModalSubmit}
                >
                  {actionText}
                </NeoButton>
              </ModalFooter>
            )}
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
